import { render, staticRenderFns } from "./infoDisplay.vue?vue&type=template&id=45b1a189&scoped=true"
import script from "./infoDisplay.vue?vue&type=script&lang=js"
export * from "./infoDisplay.vue?vue&type=script&lang=js"
import style0 from "./infoDisplay.vue?vue&type=style&index=0&id=45b1a189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1a189",
  null
  
)

export default component.exports